import { useTranslation } from 'react-i18next';

import { LocaleLink } from '../../components/navigation/LocaleLink';

/**
 * Hiking-trails promo — spec §7.1 ("hiking-trails promo cards"). A centred heading over three
 * cards; the raised centre card is the CTA into the trails map, flanked by two supporting
 * tiles. Static/marketing content (no admin list), so it lives in i18n, not the API.
 */
export function HikingTrailsPromo() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold uppercase tracking-wide text-content sm:text-3xl">
          {t('home.trailsPromoTitle')}
        </h2>
        <p className="mt-2 text-content-muted">{t('home.trailsPromoSubtitle')}</p>
      </div>

      <div className="mt-8 grid items-center gap-4 md:grid-cols-3">
        <SideTile icon="◍" label={t('home.trailsFindDestination')} />

        {/* Raised centre CTA card. */}
        <div className="order-first rounded-3xl bg-accent p-6 text-accent-contrast shadow-soft md:order-none md:-my-4 md:py-10 dark:shadow-soft-dark">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-pill bg-white/20 text-lg" aria-hidden="true">
            ⛰
          </span>
          <h3 className="mt-4 text-xl font-bold">{t('home.trailsCardTitle')}</h3>
          <p className="mt-2 text-sm text-accent-contrast/80">{t('home.trailsCardText')}</p>
          <LocaleLink
            to="/what-to-do/hiking-trail-map"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide hover:underline"
          >
            {t('home.learnMore')} →
          </LocaleLink>
        </div>

        <SideTile icon="🧭" label={t('home.trailsPlayJourney')} />
      </div>
    </section>
  );
}

function SideTile({ icon, label }: { icon: string; label: string }) {
  return (
    <div className="flex min-h-[9rem] flex-col justify-end rounded-3xl bg-ink p-6 text-white">
      <span className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-pill bg-white/15 text-lg" aria-hidden="true">
        {icon}
      </span>
      <span className="text-lg font-semibold">{label}</span>
    </div>
  );
}
